import { Check, UserPlus } from "lucide-react"
import { Avatar } from "@/components/ui/Avatar"
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/Popover"
import { cn } from "@/lib/utils"
import { PEOPLE } from "../data"

interface Props {
  value: string[]
  onChange: (value: string[]) => void
}

// Pick one or more people in charge (PIC). Nothing else: no follow-up yet.
export default function PicPicker({ value, onChange }: Props) {
  const toggle = (name: string) =>
    onChange(value.includes(name) ? value.filter((n) => n !== name) : [...value, name])

  return (
    <Popover>
      <PopoverTrigger className="flex h-9 items-center gap-1.5 rounded-md border border-input bg-background px-3 text-sm hover:bg-accent">
        {value.length === 0 ? (
          <><UserPlus className="h-4 w-4" /> PIC</>
        ) : (
          <>
            <span className="flex -space-x-1">
              {value.map((name) => <Avatar key={name} name={name} tone="primary" className="ring-2 ring-background" />)}
            </span>
            <span>{value.length === 1 ? value[0].split(" ")[0] : `${value.length} people`}</span>
          </>
        )}
      </PopoverTrigger>
      <PopoverContent className="w-56 p-1">
        {PEOPLE.map((name) => {
          const on = value.includes(name)
          return (
            <div
              key={name}
              onClick={() => toggle(name)}
              className={cn("flex cursor-pointer items-center gap-2 rounded-sm px-2 py-1.5 text-sm hover:bg-accent", on && "font-medium")}
            >
              <Avatar name={name} tone={on ? "primary" : "muted"} />
              <span className="flex-1">{name}</span>
              {on && <Check className="h-4 w-4 text-primary" />}
            </div>
          )
        })}
      </PopoverContent>
    </Popover>
  )
}
